import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { clientService } from '@/services/ClientService'
import { clientKeys } from '@/hooks/queryKeys'
import type { ClientListDto } from '@lib/dto/client.dto'
import type { ListClientsQuery } from '@lib/input/client.input'

/**
 * Load the client list for a set of filters. Returns the raw TanStack Query
 * result so callers can drive loading / empty / error states explicitly.
 *
 * `placeholderData` keeps the previous page of results on screen while a new
 * filter or search term is fetching, so typing in the search box doesn't
 * flash the table back to a skeleton on every keystroke.
 */
export function useClients(
  filters: Partial<ListClientsQuery> = {},
): UseQueryResult<ClientListDto> {
  return useQuery({
    queryKey: clientKeys.list({
      search: filters.search,
      type: filters.type,
      status: filters.status,
      includeArchived: filters.includeArchived,
    }),
    queryFn: () => clientService.list(filters),
    placeholderData: (previous) => previous,
    staleTime: 15_000,
  })
}
